import { render } from "./App.html?vue&type=template&id=562f196f&ts=true"
import script from "./App.ts?vue&type=script&lang=ts"
export * from "./App.ts?vue&type=script&lang=ts"

import "./App.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__